import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';
import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

export const downloadPortalRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/download-portal',
  component: lazyRouteComponent(() => import('@/pages/download-portal/download-portal-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});
